import React from "react";

export default class GoogleMaps extends React.Component {
  componentDidMount() {
    if (document.querySelector('script[src*="maps.googleapis.com"]')) return;

    const addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//maps.googleapis.com/maps/api/js?key=AIzaSyDbdUXwDew699WbUi6Yz2m6n6cIV4EBrAw&libraries=places&callback=mapCallback"
    );
    document.body.appendChild(addScript);
  }

  render() {
    return <div></div>;
  }
}
